import * as React from 'react';
import styles from './StarredButton.module.css';
import { useStarredPins } from 'hooks/useStarredPins';
import { StarredModal } from './StarredModal';
import { useSelector } from 'react-redux';
import { selectHasViewedStarredPinModal } from 'ducks/client/starredPins';

interface Props {
  pinKey: string;
}

export const StarredButton = ({ pinKey }: Props) => {
  const { isStarred, toggleStar } = useStarredPins();
  const hasViewedStarredPinModal = useSelector(selectHasViewedStarredPinModal);
  const [showStarredModal, setShowStarredModal] = React.useState(false);

  return (
    <>
      {showStarredModal && <StarredModal onClose={() => setShowStarredModal(false)} />}
      <div
        className={styles.container}
        onClick={(e) => {
          e.stopPropagation();

          if (!isStarred(pinKey) && !hasViewedStarredPinModal) {
            setShowStarredModal(true);
          }

          toggleStar(pinKey);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="19"
          height="17"
          viewBox="0 0 19 17"
          fill="none"
        >
          <path
            d="M10.1468 1.62756L12.0644 5.49894C12.108 5.59721 12.1766 5.68232 12.2634 5.74581C12.3501 5.80928 12.452 5.84892 12.5588 5.86075L16.792 6.48789C16.9147 6.50364 17.0302 6.55395 17.1252 6.63293C17.2203 6.7119 17.2909 6.81629 17.3288 6.9339C17.3668 7.05151 17.3704 7.17749 17.3394 7.29712C17.3085 7.41676 17.2441 7.52509 17.1538 7.6095L14.1025 10.6367C14.0247 10.7094 13.9663 10.8005 13.9326 10.9016C13.8988 11.0027 13.891 11.1106 13.9096 11.2156L14.6453 15.4728C14.6666 15.5952 14.6531 15.721 14.6064 15.8361C14.5597 15.9511 14.4817 16.0507 14.3811 16.1237C14.2807 16.1966 14.1616 16.2397 14.0378 16.2484C13.9139 16.257 13.7901 16.2307 13.6804 16.1723L9.86938 14.1582C9.7718 14.1104 9.66453 14.0855 9.55581 14.0855C9.4471 14.0855 9.33984 14.1104 9.24225 14.1582L5.43117 16.1723C5.32153 16.2307 5.19773 16.257 5.07386 16.2484C4.94999 16.2397 4.83101 16.1966 4.73049 16.1237C4.62995 16.0507 4.5519 15.9511 4.5052 15.8361C4.45851 15.721 4.44504 15.5952 4.46634 15.4728L5.20202 11.1673C5.22067 11.0624 5.21278 10.9545 5.17908 10.8534C5.14539 10.7522 5.08693 10.6612 5.00906 10.5884L1.92161 7.6095C1.83027 7.52279 1.76603 7.41144 1.73668 7.28896C1.70733 7.16648 1.71413 7.03811 1.75624 6.91941C1.79836 6.80071 1.874 6.69678 1.97399 6.62018C2.07398 6.5436 2.19403 6.49764 2.3196 6.48789L6.55278 5.86075C6.65964 5.84892 6.76153 5.80928 6.84829 5.74581C6.93505 5.68232 7.00365 5.59721 7.04726 5.49894L8.96486 1.62756C9.01708 1.51481 9.10046 1.41935 9.20518 1.35245C9.30989 1.28555 9.43156 1.25 9.55581 1.25C9.68007 1.25 9.80175 1.28555 9.90646 1.35245C10.0112 1.41935 10.0946 1.51481 10.1468 1.62756Z"
            stroke="#ff8360"
            fill={isStarred(pinKey) ? '#ff8360' : 'none'}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </>
  );
};
